__turbopack_context__.v({
  "mobile-store-icon": "mobile-store-module-scss-module__M1i2PW__mobile-store-icon",
  "step-midnight": "mobile-store-module-scss-module__M1i2PW__step-midnight",
  "step-white": "mobile-store-module-scss-module__M1i2PW__step-white",
});
